"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const PortalContext = React.createContext([]);
exports.PortalConsumer = PortalContext.Consumer;
exports.PortalManager = ({ children, portals }) => (React.createElement(PortalContext.Provider, { value: portals }, children));
